import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-bl-apply-now.component.scss';
var FormItemBlApplyNow = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBlApplyNow, _super);
    function FormItemBlApplyNow(element) {
        return _super.call(this, element) || this;
    }
    FormItemBlApplyNow.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displayMessage = this.form.querySelector(".form-container__message");
            this.displayMessageFail = this.form.querySelector(".form-container__message-fail");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayDeclined = this.form.querySelector(".form-container__declined");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        // inputs
        this.entityType = this.element.querySelector(".js-apply-now-entity-type");
        this.businessFields = Array.from(this.element.querySelectorAll(".js-bl-apply-now__visible-business"));
        this.southAfricanIdField = this.element.querySelector(".js-bl-apply-now__visible-id");
        this.currentBank = this.element.querySelector("select[name=current-bank]");
        // buttons
        this.buttonConfirmCustomer = this.form.querySelector(".js-blApplyPc__button--confirmCustomer");
        this.buttonSubmit = Array.from(this.element.querySelectorAll(".js-blApplyPc__button--submit"));
        // hidden
        this.hidLeadId = this.form.querySelector("input[name=leadId]");
        this.hidProduct = this.form.querySelector("input[name=product]");
        if (this.entityType) {
            this.updateForm(this.entityType.value);
        }
    };
    FormItemBlApplyNow.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            }); });
        }
        if (this.buttonConfirmCustomer) {
            this.buttonConfirmCustomer.addEventListener("click", function (event) {
                var _confirmed = _this.displayMessage.querySelector("input[name=customer-confirm]:checked");
                if (_confirmed) {
                    if (_confirmed.value === "yes") {
                        _this.showDisplayView("fields");
                    }
                    else {
                        _this.showDisplayView("messageFail");
                        // Resize to display Business Current Account Cross-Sell
                        var formModal = _this.element.closest(".modal").querySelector(".modal__dialog--small");
                        if (formModal) {
                            formModal.classList.remove("modal__dialog--small");
                            formModal.classList.add("modal__dialog--large");
                        }
                    }
                }
            });
        }
        if (this.currentBank) {
            this.currentBank.addEventListener("change", function (pEvent) {
                var _currentBank = pEvent.target.value;
                var _redirectedFrom = _this.getRedirectPage();
                if (_currentBank !== "STANDARD_BANK") {
                    var tellMeMoreBtn = _this.element.querySelector(".business-lending__tell-me-more--button");
                    if (_this.displayDeclined && tellMeMoreBtn) {
                        _this.showDisplayView("declined");
                        tellMeMoreBtn.setAttribute("href", "/southafrica/business/products-and-services/borrow-for-your-needs/cash-flow-solutions/business-term-loan?cusIsRedirected=YES&productRedirectedFrom=" + _redirectedFrom + "&cusBank=" + _currentBank);
                    }
                }
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (event) {
                _this.updateForm(_this.entityType.value);
            });
        }
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js-bl-apply-now__visible-business");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            // This will reset step 2
            if (_this.entityType) {
                _this.updateForm(_this.entityType.value);
            }
            // Check if modal is custom, if not, resize
            var formModal = _this.element.closest(".modal").querySelector(".modal__dialog--large");
            if (formModal) {
                if (!formModal.closest(".form-container-related-links")) {
                    formModal.classList.remove("modal__dialog--large");
                    formModal.classList.add("modal__dialog--small");
                }
            }
            _this.form.reset();
            _this.showDisplayView("");
        }, false);
    };
    FormItemBlApplyNow.prototype.updateForm = function (type) {
        if (this.southAfricanIdField) {
            var _group = this.southAfricanIdField.closest(".form__group");
            if (type !== "SOLE") {
                this.southAfricanIdField.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
            }
            else {
                this.southAfricanIdField.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
        if (this.businessFields) {
            this.businessFields.forEach(function (elem) {
                var _group = elem.closest(".form__group ");
                if (type !== "SOLE") {
                    elem.classList.add("form__input--required");
                    _group.classList.remove("form__group--hidden");
                }
                else {
                    elem.classList.remove("form__input--required");
                    _group.classList.add("form__group--hidden");
                }
            });
        }
    };
    FormItemBlApplyNow.prototype.getRedirectPage = function () {
        if (window.location.href.includes("business-overdraft")) {
            return 'BUSINESS_OVERDRAFT';
        }
        else if (window.location.href.includes("revolving-credit-plan")) {
            return 'BRCP';
        }
        else if (window.location.href.includes("agricultural-production-loan")) {
            return 'BUSINESS_AGRI_LOAN';
        }
        else if (window.location.href.includes("fixed-repayments-business-loan")) {
            return 'BUS_FIXED_REPAYMENTS';
        }
        else {
            return '';
        }
    };
    FormItemBlApplyNow.prototype.submitForm = function (form) {
        var _this = this;
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        // Hidden fields
        var _serviceType = form.querySelector("input[name=service-type]");
        var _product = form.querySelector("input[name=product]");
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _description = form.querySelector("input[name=description]");
        var _subject = form.querySelector("input[name=subject]");
        var _redirect = form.querySelector("input[name=redirect]");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        // Parameters
        var _loanAmount = this.form.querySelector("input[name=loan-amount]");
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _alternativeContactNumber = this.form.querySelector("input[name=alternative-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _idNumber = this.form.querySelector("input[name=sa-identity-number]");
        var _businessRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _businessDo = this.form.querySelector("input[name=business-do]");
        var _businessAccountCurrentlyHeld = this.form.querySelector("select[name=business-account]");
        var _accountNumber = this.form.querySelector("input[name=account-number]");
        var _turnOver = this.form.querySelector("input[name=turnover-tax]");
        var _purpose = this.form.querySelector("textarea[name=purpose]");
        var postData = {
            'service-type': (_serviceType ? _serviceType.value : ""),
            'product': (_product ? _product.value : ""),
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'description': (_description ? _description.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'redirect': (_redirect ? _redirect.value : ""),
            'how-much-do-you-need': (_loanAmount ? _loanAmount.value : ""),
            'firstname': (_firstName ? _firstName.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNo': (_contactNumber ? _contactNumber.value : ""),
            'altContactNo': (_alternativeContactNumber ? _alternativeContactNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'entityType': (_entityType ? _entityType.value : ""),
            'businessName': (_businessName ? _businessName.value : ""),
            'saId': (_idNumber.value ? _idNumber.value : ""),
            'business-registration': (_businessRegNumber ? _businessRegNumber.value : ""),
            'business-description': (_businessDo ? _businessDo.value : ""),
            'bankName': (_businessAccountCurrentlyHeld ? _businessAccountCurrentlyHeld.value : ""),
            'bankAccountNo': (_accountNumber.value ? _accountNumber.value : ""),
            'monthlyTurnOver': (_turnOver ? _turnOver.value : ""),
            'purpose': (_purpose ? _purpose.value : ""),
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/services/SubmitGenericForm.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(postData)).then(function (response) {
            if (response.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", "false");
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                name.map(function (_item) {
                    _item.innerHTML = _firstName.value;
                });
                _this.analyticsService.dtmFormComplete("complete", response.code);
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    // add remove displays
    FormItemBlApplyNow.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        this.displayMessageFail.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayDeclined.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            case "messageFail":
                this.displayMessageFail.classList.remove("hidden");
                break;
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "declined":
                this.displayDeclined.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayMessage.classList.remove("hidden");
                break;
        }
    };
    return FormItemBlApplyNow;
}(Base));
export { FormItemBlApplyNow };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-bl-apply-now/form-item-bl-apply-now.component.ts
// module id = 831
// module chunks = 0